import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { IIncomeTaxState } from './store/incomeTax.state';
import { getIncomeTaxSelectors } from './store/incomeTax.selectors';
import { setIncomeTaxAction } from './store/incomeTax.actions';
import { IIncomeTax } from 'src/app/modules/interfaces/income-taxes.interface';
import { IncomeService } from 'src/app/services/income-taxes.service';
import { getCookie } from 'src/app/utils/get-cookie';

@Component({
  selector: 'app-income-tax',
  templateUrl: './income-tax.component.html',
  styleUrls: ['./income-tax.component.scss'],
})
export class IncomeTaxComponent implements OnInit {
  @Output() formSaved = new EventEmitter<void>();

  formsId: number;

  taxTypesMap = {
    1: 'Simplificada',
    2: 'Completa',
    3: 'Sou isento(a)',
  };

  incomeTaxData: IIncomeTax = {
    id: 0,
    income_tax_types_id: null,
    refunds_last_year: null,
    income_tax_refunds: null,
  };

  dataState$: Observable<IIncomeTaxState>;
  dataState: IIncomeTaxState;

  isLoading = true;
  isSaving = false;
  saveButtonText = 'Salvar';
  saveButtonClass = 'btn-primary';

  constructor(private store: Store, private incomeTaxService: IncomeService) {
    this.formsId = Number(getCookie('formsId'));
  }

  ngOnInit(): void {
    this.getState();
    this.loadIncomeTaxData();
  }

  loadIncomeTaxData(): void {
    this.isLoading = true;
    this.incomeTaxService.getIncomeData(this.formsId).subscribe((response) => {
      if (response) {
        this.incomeTaxData = {
          id: response.id,
          income_tax_types_id: String(response.income_tax_types_id),
          refunds_last_year: response.refunds_last_year,
          income_tax_refunds: response.income_tax_refunds,
        };
        this.saveState()
      }
    });
  }

  saveForm(): void {
    this.isSaving = true;
    this.saveButtonText = 'Salvando...';
    this.saveButtonClass = 'btn-secondary';

    const updateData: any = {
      income_tax_types_id: Number(this.incomeTaxData.income_tax_types_id),
      refunds_last_year: this.incomeTaxData.refunds_last_year,
    };

    if (
      this.incomeTaxData.refunds_last_year === 'Sim' &&
      this.incomeTaxData.income_tax_refunds
    ) {
      updateData.income_tax_refunds = this.incomeTaxData.income_tax_refunds;
    }

    this.incomeTaxService
      .updateIncomeData(this.formsId, this.incomeTaxData.id, updateData)
      .subscribe({
        next: () => {
          this.isSaving = false;
          this.saveButtonText = 'Salvo';
          this.saveButtonClass = 'btn-primary';
          this.saveState()
          this.formSaved.emit();
        },
        error: () => {
          this.isSaving = false;
          this.saveButtonText = 'Erro ao salvar';
          this.saveButtonClass = 'btn-danger';
        },
      });
  }

  saveState(): void {
    const taxName = this.taxTypesMap[this.incomeTaxData.income_tax_types_id] || '';
    this.dataState = {
      ...this.dataState,
      check: true,
      typeTax: taxName,
      refunded: this.incomeTaxData.refunds_last_year,
      amount: this.incomeTaxData.income_tax_refunds || 0,
    };

    this.setState(this.dataState);
  }

  onFieldChange(): void {
    if (!this.isSaving) {
      this.saveButtonText = 'Salvar';
      this.saveButtonClass = 'btn-primary';
    }
  }

  updateAmount(event): void {
    this.incomeTaxData.income_tax_refunds = event;
    this.onFieldChange();
  }

  setState(data: IIncomeTaxState) {
    this.store.dispatch(setIncomeTaxAction(data));
    this.isLoading = false;
  }

  getState() {
    this.dataState$ = this.store.select(getIncomeTaxSelectors);

    this.dataState$.subscribe((value) => {
      this.dataState = {
        ...(this.dataState = value),
      };
    });
  }

  setValuesForm(): void {
    this.dataState.check = false;
    if (this.dataState.typeTax != undefined) {
      this.dataState.check = true;
    }
    this.setState(this.dataState);
  }

}
